// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root___YQy6","range":"MonthRangeSwitch_range__1frr6","disabled":"MonthRangeSwitch_disabled__2ZgV7"};